if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.slides = this.slider ? this.slider.querySelectorAll('.announcement__slide') : [];
      this.isPaused = false;
      this.currentIndex = 0;
      this.slideDelay = parseInt(this.dataset.slideDelay, 10) || 5000;

      this.bindEvents();
      this.init();
    }

    bindEvents() {
      if (this.slider) {
        this.slider.addEventListener('mouseenter', () => { this.isPaused = true; });
        this.slider.addEventListener('mouseleave', () => { this.isPaused = false; });
      }
    }

    init() {
      if (!this.slider || this.slides.length <= 1) return;

      const tick = () => {
        if (!this.isPaused && this.isMobile() && this.isInViewport()) {
          this.nextSlide();
        }
        setTimeout(tick, this.slideDelay);
      };
      setTimeout(tick, this.slideDelay);
    }

    isMobile() {
      // Zelfde grens als announcement.css: onder 1200px draait de carousel
      return window.matchMedia('(max-width: 1199px)').matches;
    }

    isInViewport() {
      if (window.theme && theme.elementUtil && typeof theme.elementUtil.isInViewport === 'function') {
        return theme.elementUtil.isInViewport(this);
      }
      const rect = this.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
    }

    nextSlide() {
      if (!this.slides.length) return;

      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      const target = this.slides[this.currentIndex];
      if (!target) return;

      const left = document.dir === 'rtl' ? -Math.abs(target.offsetLeft) : target.offsetLeft;
      this.slider.scrollTo({ left: left, behavior: 'smooth' });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
